import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';
import { translations } from './Translations.js';

function init() {
  i18next
    .use(XHR)
    .use(LanguageDetector)
    .init({
      debug: false,
      fallbackLng: 'en', // use en if detected lng is not available

      keySeparator: '.',

      interpolation: {
        escapeValue: false, // react already safes from xss
      },
      resources: {
        es: { translation: translations.es },
        en: { translation: translations.en },
        pt: { translation: translations.pt },
        fr: { translation: translations.fr },
      },
      detection: {
        order: ['htmlTag', 'querystring', 'path', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'subdomain'],
      },
    });
}

export default { init };
